const API_BASE = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8000/api/v1';
const TOKEN_KEY = 'manejai_manager_token';

type ApiEnvelope<T> = {
  success: boolean;
  data?: T;
  error?: { message: string; code?: string };
};

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export async function adminFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  const token = getToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);
  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(`${API_BASE}/admin${path}`, { ...init, headers });
  const body = (await response.json().catch(() => null)) as ApiEnvelope<T> | null;

  if (!response.ok || !body?.success) {
    throw new Error(body?.error?.message ?? `Erro HTTP ${response.status}`);
  }

  return body.data as T;
}

export type InternalUser = {
  id: number;
  name: string;
  email: string;
  role: string;
};

export type ClientStats = {
  id: number;
  trade_name: string;
  legal_name: string;
  plan_code: string | null;
  status: string;
  modules?: Record<string, boolean>;
  sales_compliance_country?: string | null;
  animals_active: number;
  ml_assets: number;
  ml_photos: number;
  ml_videos: number;
  ml_storage_bytes: number;
};

export type MlCurationJson = {
  internal_number?: string;
  animal_name?: string;
  sex?: string;
  category_code?: string;
  drive_categoria?: string;
  roboflow_split?: 'train' | 'valid' | 'test';
  roboflow_tags?: string[];
};

export type MlMediaItem = {
  id: number;
  client_id: number;
  media_kind: 'photo' | 'video';
  url: string;
  thumbnail_url: string | null;
  captured_at: string | null;
  review_status: 'pending' | 'approved' | 'rejected';
  curation_notes: string | null;
  curation_json: MlCurationJson | null;
  export_labels: Record<string, unknown>;
  animal_snapshot: Record<string, unknown> | null;
  metadata: Record<string, unknown> | null;
};

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}
